import { ArrowRight, ArrowUpRight, Grid3X3 } from "lucide-react";
import Navigation from "@/components/site/Navigation";
import Footer from "@/components/site/Footer";
import { useQuote } from "@/lib/quoteContext";

const HERO_IMG =
  "https://images.unsplash.com/photo-1600210492486-724fe5c67fb0?auto=format&fit=crop&w=1800&q=85";

const PROJECTS = [
  {
    title: "现代简约",
    label: "Modern Minimal",
    url: "https://vr.justeasy.cn/view/w10781347n897p99-1781532737.html",
  },
  {
    title: "侘寂风",
    label: "Wabi-Sabi",
    url: "https://vr.justeasy.cn/view/1768l2l33t721r64-1782372184.html",
  },
  {
    title: "宋氏美学",
    label: "Song Aesthetic",
    url: "https://vr.justeasy.cn/view/1782v2c46515atl3-1782265697.html",
  },
  {
    title: "法式中古",
    label: "French Vintage",
    url: "https://vr.justeasy.cn/view/1tzl7b7612g05750-1780257901.html",
  },
  {
    title: "简欧",
    label: "Simple European",
    url: "https://vr.justeasy.cn/view/s17n82l35a710ys8-1782380270.html",
  },
  {
    title: "北欧",
    label: "Nordic",
    url: "https://vr.justeasy.cn/view/178ny0m4d0698507-1780644651.html",
  },
  {
    title: "法式",
    label: "French",
    url: "https://vr.justeasy.cn/view/1q1781b08gr08386-1780808386.html",
  },
  {
    title: "日式",
    label: "Japanese",
    url: "https://vr.justeasy.cn/view/1q1781b08gr08386-1780808386.html",
  },
  {
    title: "美式",
    label: "American",
    url: "https://vr.justeasy.cn/view/1q1781b08gr08386-1780808386.html",
  },
  {
    title: "中式",
    label: "Chinese",
    url: "https://vr.justeasy.cn/view/174807yc494s7115-1780746929.html",
  },
  {
    title: "新中式",
    label: "New Chinese",
    url: "https://vr.justeasy.cn/view/v17a850v2v71k990-1780362653.html",
  },
  {
    title: "港式",
    label: "Hong Kong",
    url: "https://vr.justeasy.cn/view/g1779a0r7959l4y0-1779076325.html",
  },
  {
    title: "新古典",
    label: "Neoclassical",
    url: "https://vr.justeasy.cn/view/1780elo5zum78715-1780579580.html",
  },
  {
    title: "轻奢",
    label: "Light Luxury",
    url: "https://vr.justeasy.cn/view/q617ea8402224879-1780812279.html",
  },
  {
    title: "东南亚",
    label: "Southeast Asian",
    url: "https://vr.justeasy.cn/view/1u72a80pz46q5389-1780541438.html",
  },
  {
    title: "地中海",
    label: "Mediterranean",
    url: "https://vr.justeasy.cn/view/j1737c9569s5uz10-1779907412.html",
  },
  {
    title: "混搭",
    label: "Mixed Style",
    url: "https://vr.justeasy.cn/view/17080i5ci40342w1-1780542352.html",
  },
  {
    title: "意式",
    label: "Italian",
    url: "https://vr.justeasy.cn/view/1js78bwlh0712270-1780715988.html",
  },
  {
    title: "轻中古风",
    label: "Soft Vintage",
    url: "https://vr.justeasy.cn/view/17r80iq3718ow553-1780402272.html",
  },
  {
    title: "奶油（中古）",
    label: "Cream Vintage",
    url: "https://vr.justeasy.cn/view/a178y231cav81769-1782387400.html",
  },
  {
    title: "奶油",
    label: "Cream",
    url: "https://vr.justeasy.cn/view/4p1xp780w2g98964-1780299060.html",
  },
  {
    title: "工业风",
    label: "Industrial",
    url: "https://vr.justeasy.cn/view/1t7e86i41642s1m3-1764164844.html",
  },
  {
    title: "原木",
    label: "Natural Wood",
    url: "https://vr.justeasy.cn/view/117820313a0e3q33-1782374788.html",
  },
  {
    title: "MUJI 风",
    label: "MUJI",
    url: "https://vr.justeasy.cn/view/o170761m273490b9-1776210203.html",
  },
  {
    title: "田园风",
    label: "Pastoral",
    url: "https://vr.justeasy.cn/view/1q78zmi7231o1318-1782463840.html",
  },
  {
    title: "南洋风",
    label: "Nanyang",
    url: "https://vr.justeasy.cn/view/1o7le818095v72h0-1781941989.html",
  },
];

export default function ProjectsPage() {
  const { openQuote } = useQuote();

  return (
    <main data-testid="projects-page" className="bg-ink-50">
      <Navigation />

      <section
        data-testid="projects-hero"
        className="relative min-h-[62vh] flex items-end overflow-hidden bg-ink text-white pt-32 pb-14 md:pb-16"
      >
        <img
          src={HERO_IMG}
          alt="Interior furnishing project"
          className="absolute inset-0 w-full h-full object-cover opacity-55"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-ink/75 via-ink/55 to-ink" />
        <div className="absolute inset-0 grain opacity-20" aria-hidden />

        <div className="relative max-w-7xl mx-auto px-6 md:px-12 w-full">
          <div className="inline-flex items-center gap-3 border border-white/15 bg-white/5 px-4 py-2 text-white/75">
            <Grid3X3 className="w-4 h-4 text-signal" strokeWidth={1.6} />
            <span className="font-mono text-[11px] uppercase tracking-[0.24em]">
              VR project library
            </span>
          </div>
          <h1 className="mt-7 font-heading font-black tracking-[-0.035em] leading-[0.9] text-5xl md:text-7xl lg:text-[104px] uppercase">
            Interior<br />
            <span className="text-stroke-light">styles.</span>
          </h1>
          <p className="mt-7 max-w-2xl text-white/78 text-base md:text-lg leading-relaxed">
            Explore curated VR references for furnishing, fit-out and design
            direction. Each style opens as a full immersive preview.
          </p>
        </div>
      </section>

      <section className="bg-white py-14 md:py-24 border-b border-ink-100">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-8 lg:gap-12 items-end">
            <div className="lg:col-span-8">
              <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-signal mb-5">
                Projects · {PROJECTS.length} VR references
              </p>
              <h2 className="font-heading font-black text-ink-900 tracking-[-0.03em] leading-[0.95] text-4xl md:text-5xl lg:text-6xl">
                Choose a direction.<br />
                <span className="text-stroke">Open the room.</span>
              </h2>
            </div>
            <p className="lg:col-span-4 text-ink-500 text-base leading-relaxed">
              These previews are kept compact for scanning. Select any tile to
              open the original JustEasy VR scene.
            </p>
          </div>
        </div>
      </section>

      <section className="bg-ink-50 py-10 md:py-16">
        <div className="max-w-7xl mx-auto px-6 md:px-12">
          <div
            data-testid="projects-grid"
            className="grid grid-cols-1 sm:grid-cols-2 xl:grid-cols-3 gap-4 md:gap-5"
          >
            {PROJECTS.map((project, index) => (
              <article
                key={`${project.title}-${project.url}`}
                data-testid={`project-card-${index + 1}`}
                className="group relative bg-white border border-ink-100 hover:border-signal hover:-translate-y-1 transition-all duration-300 overflow-hidden"
              >
                <div className="relative aspect-[16/10] bg-ink overflow-hidden">
                  <img
                    src={`/${index + 1}.png`}
                    alt={`${project.title} interior preview`}
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-ink/45 via-transparent to-transparent opacity-80 group-hover:opacity-35 transition-opacity" />
                  <span className="absolute top-4 left-4 font-mono text-[10px] uppercase tracking-[0.22em] text-white bg-ink/80 border border-white/10 px-3 py-1.5">
                    {String(index + 1).padStart(2, "0")}
                  </span>
                </div>

                <div className="p-6 md:p-7">
                  <div className="flex items-start justify-between gap-4">
                    <div>
                      <h3 className="font-heading font-black text-ink-900 tracking-[-0.02em] leading-none text-3xl">
                        {project.title}
                      </h3>
                      <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.2em] text-ink-500">
                        {project.label}
                      </p>
                    </div>
                    <span className="mt-1 w-10 h-10 flex items-center justify-center border border-ink-100 text-ink-900 group-hover:border-signal group-hover:text-signal transition-colors flex-shrink-0">
                      <ArrowUpRight className="w-4 h-4" strokeWidth={1.7} />
                    </span>
                  </div>
                </div>

                <a
                  href={project.url}
                  data-testid={`project-link-${index + 1}`}
                  aria-label={`Open ${project.title} VR project`}
                  className="absolute inset-0 z-10"
                />
              </article>
            ))}
          </div>
        </div>
      </section>

      <section className="bg-white py-14 md:py-24 border-t border-ink-100">
        <div className="max-w-7xl mx-auto px-6 md:px-12 grid grid-cols-1 md:grid-cols-12 gap-8 md:gap-12 items-center">
          <div className="md:col-span-8">
            <p className="font-mono text-[11px] uppercase tracking-[0.28em] text-signal mb-5">
              Have a project?
            </p>
            <h2 className="font-heading font-black text-ink-900 tracking-[-0.03em] leading-[0.95] text-4xl md:text-5xl lg:text-6xl">
              Send us the style.<br />
              <span className="text-stroke">We'll source the finish.</span>
            </h2>
          </div>
          <div className="md:col-span-4 flex md:justify-end">
            <button
              type="button"
              onClick={openQuote}
              data-testid="projects-cta-quote"
              className="inline-flex items-center gap-2 bg-signal hover:bg-signal-600 text-white px-6 py-3.5 font-mono text-[12px] uppercase tracking-[0.22em] transition-colors"
            >
              Start a Project
              <ArrowRight className="w-4 h-4" />
            </button>
          </div>
        </div>
      </section>

      <Footer />
    </main>
  );
}
